// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Xa0-","title":"InfoRow_title__1Z-KU"};